import { dataSelector } from '../api'

export const monthyReportListSelector = dataSelector('monthlyReportList')

export const weeklyReportSelector = dataSelector('weeklyReport')

export const pumpReportListSelector = dataSelector('pumpReportList')

export const pumpReportSelector = dataSelector('pumpReportDetail')
